import { FC, Suspense, useEffect } from 'react';

import { useTenantedApplicationConfig } from '~/core/shared/contexts';
import { WorkflowCustomStep } from '~/core/shared/types';
import { useLayoutWrap } from './contexts/layoutWrap';

type CustomStepRendererProps = {
  step: WorkflowCustomStep;
};

export const CustomStepRenderer: FC<CustomStepRendererProps> = ({ step }) => {
  const config = useTenantedApplicationConfig();
  const { setPageWidth } = useLayoutWrap();

  const CustomStepComponent =
    config.getWorkflowConfig().customSteps?.[step.key];

  if (!CustomStepComponent) {
    console.error(
      `No custom step found. Add "${step.key}" to "config.getWorkflowConfig().customSteps"`,
    );
    return null;
  }

  useEffect(() => {
    setPageWidth(step?.layoutWidth || 'md');
  }, [step]);

  return (
    <Suspense fallback={null}>
      <CustomStepComponent step={step} />
    </Suspense>
  );
};
